import script from "./donate.vue?vue&type=script&lang=ts&setup=true"
export * from "./donate.vue?vue&type=script&lang=ts&setup=true"

import "./donate.vue?vue&type=style&index=0&id=da7b0140&scoped=true&lang=css"

import exportComponent from "/Users/niming/Documents/vue-mooc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da7b0140"]])

export default __exports__